export default __webpack_public_path__ + "images/0x8d9ba570d6cb60c7e3e0f31343efe75ab8e65fb1.png";